import React from "react";
import "core-js";
import ReactGA from "react-ga";
import { MuiThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Highcharts from "highcharts";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsExportData from "highcharts/modules/export-data";
import HighchartsOfflineExporting from "highcharts/modules/offline-exporting";
import theme from "./theme";
import AppContainer from "./containers/AppContainer";

ReactGA.initialize("UA-59586848-1");

Highcharts.setOptions({
  lang: {
    numericSymbols: ["K", "m", "bn", "trn"]
  }
});

HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);
HighchartsOfflineExporting(Highcharts);

const Root = () => (
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    <AppContainer />
  </MuiThemeProvider>
);

export default Root;
